<template>
  <div>
    <div class="d-flex justify-content-between button-group">
      <div>
        <b-button v-if="!isNewPrice" @click="openHistoryModal">{{$t('buttons.common.history')}}</b-button>
        <history-modal-content></history-modal-content>
        <price-create-modal :price="param" :priceList="priceData" :selectedPrice="selectedRows" ></price-create-modal>
      </div>
      <div v-if="currentRoutePermissions.change_purchasecontract">
        <b-button class="btn" v-if="!isNewPrice && isActivePrice" variant="success"
                  @click="completeContract" size="sm">
          {{$t('buttons.price_list.complete_price')}}
        </b-button>
        <b-button class="btn" v-if="!isActivePrice" variant="success" @click="recoverPrice" size="sm">
          {{$t('buttons.price_list.recover_price')}}
        </b-button>
        <b-button v-if="isActivePrice" class="btn" variant="outline-success" @click="saveAsNew" size="sm">
          {{$t('buttons.common.save_as_new')}}
        </b-button>
        <b-button v-if="isActivePrice" class="btn" variant="secondary" @click="save" size="sm">
          {{$t('buttons.common.save')}}
        </b-button>
      </div>
    </div>
    <div class="d-flex justify-content-between toggle-container" @click="showCollapse = !showCollapse"
         :aria-expanded="showCollapse ? 'true' : 'false'"
         aria-controls="collapse">
      <h3>
        {{contractLabel}}
        <span v-if="!isNewPrice"
              :style="{color: isActivePrice ? 'green' : 'red'}"> - {{priceData.status}}</span>
      </h3>
      <div class="icons-wrapper">
        {{priceInfo}}
        <icon name="angle-down" class="angle" v-if="showCollapse"></icon>
        <icon name="angle-right" class="angle" v-else></icon>
      </div>
    </div>
    <b-collapse id="collapse" v-model="showCollapse">
      <div class="search-form">
        <div class="search-form__filters">
          <b-row>
            <b-col>
              <label>{{$t('labels.price_list.price_list_number')}}</label>
              <input class="form-control" v-model="priceData.price_list_nr"
                     placeholder="" :disabled="!isActivePrice"
                     :class="{ required: (!priceData.price_list_nr) }">
            </b-col>
            <b-col>
              <label>{{$t('labels.common.currency')}}</label>
              <multiselect
                v-model="priceData.currency"
                :max-height="200"
                placeholder="" label="code" track-by="id"
                @select="setCurrency"
                :options="currencies" :multiple="false" :disabled="!isActivePrice"
                :class="{ required: (!priceData.currency) }"
                taggable close-on-select></multiselect>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.measure_type')}}</label>
              <input class="form-control" value="m3" :disabled="true">
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <label>{{$t('labels.price_list.date')}}</label>
              <datepicker v-model="priceData.date_start" lang="en" :disabled="!isActivePrice"
                          placeholder=""
                          :class="{ required: (!priceData.date_start) }" :first-day-of-week="1"
              ></datepicker>
            </b-col>
            <b-col>
              <label>{{$t('labels.price_list.expiration_date')}}</label>
              <datepicker v-model="priceData.delivery_term" lang="en" :disabled="priceData.status === 'completed'"
                          placeholder=""
                          :first-day-of-week="1"
              ></datepicker>
            </b-col>
            <b-col>
              <label>{{$t('labels.common.notes')}}</label>
              <b-form-textarea v-model="priceData.notes"
                               placeholder=""
                               :disabled="!isActivePrice">
              </b-form-textarea>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-collapse>
    <b-card no-body v-if="!isNewPrice">
      <b-tabs card>
        <b-tab active>
          <template slot="title">
            <portal-target name="lots"></portal-target>
          </template>
          <div class="d-flex justify-content-between button-group">
            <portal to="lots">
              {{$t('tabs.price_list.prices')}}
            </portal>
            <div>
              {{$t('labels.common.selected')}}: {{selectedRowsCount}}
              <b-button v-if="isActivePrice && currentRoutePermissions.change_purchasecontract" class="btn"
                        variant="danger" @click="deletePrice" size="sm" :disabled="isOneOfSelectedIsCompleted">
                {{$t('buttons.price_list.delete_price')}}
              </b-button>
              <b-button v-if="isActivePrice && currentRoutePermissions.change_purchasecontract" class="btn"
                        @click="completePrice" variant="secondary"
                        size="sm">
                {{$t('buttons.price_list.complete_price')}}
              </b-button>
              <b-button v-if="isActivePrice && currentRoutePermissions.change_purchasecontract" class="btn"
                        @click="openProlongPriceModal"
                        variant="secondary"
                        size="sm">
                {{$t('buttons.price_list.prolong_price')}}
              </b-button>
              <b-modal ref="prolongPriceModal"
                       size="sm"
                       ok-only
                       :title="prolongPriceModalTitle"
                       ok-title="Save"
                       @ok="prolongPrice"
                       ok-variant="success"
                       :no-close-on-backdrop="true"
              >
                <b-row>
                  <b-col>
                    <label>{{$t('labels.price_list.price')}}</label>
                    <multiselect v-model="priceProlongData.lots" :max-height="200"
                                 placeholder=""
                                 :options="priceProlongData.lots" :multiple="true"
                                 :disabled="true"
                                 :taggable="true" :close-on-select="false"></multiselect>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <label>{{$t('labels.common.end_date')}}</label>
                    <datepicker v-model="priceProlongData.date_end" lang="en"
                                :class="{ required: (!priceProlongData.date_end) }"
                                placeholder=""
                                :not-before="currentDate" :first-day-of-week="1"
                    ></datepicker>
                  </b-col>
                </b-row>
              </b-modal>
            </div>
            <div>
              <b-button v-if="isActivePrice && currentRoutePermissions.change_purchasecontract" class="btn"
                        variant="success" @click="openCreatePriceModal"
                        size="sm">
                {{$t('buttons.price_list.create_price')}}
              </b-button>
            </div>
          </div>
          <ag-grid-vue class="ag-theme-balham" :gridOptions="gridOptions" :style="gridHeight"
                       :columnDefs="pricesColumns" :rowData="prices" :pinnedBottomRowData="pinnedRowData"
                       :rowDoubleClicked="openCreatePriceModal" :rowDataChanged="countSelectedRows"
                       :rowSelected="countSelectedRows" :postProcessPopup="postProcessPopup">
          </ag-grid-vue>
        </b-tab>
        <b-tab>
          <template slot="title">
            <portal-target name="docs"></portal-target>
          </template>
          <portal to="docs">
            {{$t('tabs.common.documents')}}
          </portal>
          <app-documents :documents="documents" :isCollapse="showCollapse" :url="commonUrl + 'attachments/'"
                         @loadDocuments="loadDocuments"></app-documents>
        </b-tab>
        <b-tab>
          <template slot="title">
            <portal-target name="comment"></portal-target>
          </template>
          <portal to="comment">
            {{$t('tabs.common.comments')}}
          </portal>
          <app-comments :comments="comments" :url="commonUrl + 'comments/'"
                        @loadComments="loadComments"></app-comments>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import { mapGetters, mapState } from 'vuex';
  import Multiselect from 'vue-multiselect';
  import Datepicker from 'vue2-datepicker';
  import Documents from '@/components/common/Documents';
  import Comments from '@/components/common/Comments';
  import RangeDatePicker from 'vue2-datepicker';
  import moment from 'moment';
  import PriceCreateModal from '@/components/modals/PurchaseCreatePriceModal';
  import HistoryModalContent from '@/components/modals/HistoryModal';
  import { translateColumnsProperly } from '@/helpers/translate-helper'
  import {
    cleanFilters,
    getArrayByProperty,
    handlerResponse,
    setNotifyData
  } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { gridMixins } from '@/mixins';
  import { DATE_FORMAT } from '@/constants';

  export default {
    mixins: [gridMixins],
    components: {
      Multiselect,
      RangeDatePicker,
      'ag-grid-vue': AgGridVue,
      Datepicker,
      PriceCreateModal,
      HistoryModalContent,
      'app-documents': Documents,
      'app-comments': Comments
    },
    data() {
      return {
        currency: null,
        selectedRowsCount: 0,
        selectedRows: [],
        showCollapse: true,
        priceProlongData: {
          lots: [],
          date_end: ''
        },
        priceData: {
          creator: '',
          currency_code: '',
          date_end: null,
          date_start: '',
          delivery_term: null,
          measure_type: '',
          price_list_nr: '',
          status: ''
        }
      }
    },
    methods: {
      translateColumnsProperly,
      setCurrency (currency, b) {
        // this.priceData.currency = currency
        this.$set(this.priceData, 'currency', currency)
        this.$set(this.priceData, 'currency_code', currency.code)
      },
      openCreatePriceModal(params) {
        if (this.currentRoutePermissions.change_purchasecontract) {
          if (params.data) {
            this.$http.get(`purchase/prices/${params.data.id}/`).then(handlerResponse).then((response) => {
              this.$root.$emit('openCreatePriceModal', {...response, isNewPrice: false});
            });
          } else {
            this.$root.$emit('openCreatePriceModal', {
              currency: this.priceData.currency_code,
              isNewPrice: true
            })
          }
        }
      },
      prepareSaveData (obj = {}) {
        return {
          ...this.priceData,
          currency: this.priceData.currency?.id,
          measure_type: 'm3',
          status: 'active',
          date_start: this.priceData.date_start ? moment(this.priceData.date_start).format(DATE_FORMAT) : null,
          // date_end: this.priceData.delivery_term ? moment(this.priceData.delivery_term).format(DATE_FORMAT) : '',
          delivery_term: this.priceData.delivery_term ? moment(this.priceData.delivery_term).format(DATE_FORMAT) : null,
          ...obj
        }
      },
      saveAsNew () {
        const saveData = this.prepareSaveData()
        this.$http.post(`purchase/price_lists/${this.param}/save_as_new/`, saveData).then(handlerResponse).then((response) => {
          const { translateColumnsProperly } = this
          this.$store.dispatch('priceLists/loadPrices', {price_list_id: this.param, translateColumnsProperly });
          this.$notify(setNotifyData('Success', 'Price has been created!', 'success'));
          this.priceData = {...response};
          this.getPriceInfo(response.id);
          this.$router.push({path: `/price-list/${response.id}`});
        }).catch((error) => {
          console.log(error);
          notificationsRenderer(error.body, 'error');
        });
      },
      save(saveType = '') {
        const saveData = this.prepareSaveData()
        if (this.isNewPrice || saveType === 'new') {
          this.$http.post(`purchase/price_lists/`, saveData)
            .then(handlerResponse).then((response) => {
              this.priceData = {...response};
              this.getPriceInfo(response.id);
              this.$notify(setNotifyData('Success', 'Price has been created!', 'success'));
              this.$router.push({path: `/price-list/${response.id}`});
            }).catch((error) => {
              console.log(error);
              notificationsRenderer(error.body, 'error');
            })
        } else {
          this.$http.put(`purchase/price_lists/${this.param}/`, saveData).then(handlerResponse).then((response) => {
            const { translateColumnsProperly } = this
            this.$store.dispatch('priceLists/loadPrices', {price_list_id: this.param, translateColumnsProperly });
            this.$notify(setNotifyData('Success', 'Price has been saved!', 'success'));
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          });
        }
      },
      completeContract() {
        this.$http.post(`purchase/price_lists/${this.param}/move_status_forward/`, this.prepareSaveData({status: 'completed'}))
          .then(handlerResponse).then(() => {
          this.$router.push({path: `/price-list/`});
          this.$notify(setNotifyData('Success', 'Price has been completed!', 'success'));
        }).catch((error) => {
          this.$notify(setNotifyData('', 'Unable to complete the price!', 'error'));
        });
      },
      recoverPrice() {
        this.$http.post(`purchase/price_lists/${this.param}/move_status_back/`, this.prepareSaveData({status: 'active'}))
          .then((response) => {
            this.getPriceInfo(response.body.id);
            this.$notify(setNotifyData('Success', 'Price has been recovered!', 'success'));
          }).catch((error) => {
          console.log(error);
          notificationsRenderer(error.body, 'error');
        });
      },
      deletePrice() {
        if (this.gridOptions.api.getSelectedRows().length) {
          const id = getArrayByProperty(this.gridOptions.api.getSelectedRows(), 'id');
          this.$http.delete(`purchase/prices/`, {body: {id: id}}).then((response) => {
            this.$store.dispatch('priceLists/loadPriceList', {price_list_id: this.param});
            this.getPriceInfo(this.param);
            this.$notify(setNotifyData('Success', response.body, 'success'));
          }).catch((error) => {
            console.log(error);
            this.$notify(setNotifyData('Error', error.body, 'error'));
          });
        } else {
          this.$notify(setNotifyData('Error', 'Select prices for removing', 'error'));
        }
      },
      completePrice() {
        if (this.gridOptions.api.getSelectedRows().length) {
          const completePriceData = getArrayByProperty(this.gridOptions.api.getSelectedRows(), 'id').map((e) => {
            return {
              'id': e,
              'status': 'completed'
            }
          });
          this.$http.put('purchase/prices/', completePriceData).then(() => {
            const { translateColumnsProperly } = this
            this.$store.dispatch('priceLists/loadPrices', {price_list_id: this.param, translateColumnsProperly });
            this.$notify(setNotifyData('Success', 'Price information has been saved', 'success'));
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          });
        } else {
          this.$notify(setNotifyData('', 'Choose at least one price!', 'error'));
        }
      },
      openProlongPriceModal() {
        this.priceProlongData.lots = getArrayByProperty(this.gridOptions.api.getSelectedRows(), 'price_nr');
        if (this.priceProlongData.lots.length) {
          this.priceProlongData.date_end = '';
          this.$refs['prolongPriceModal'].show();
        } else {
          this.$notify(setNotifyData('', 'Choose at least one price for edit', 'error'));
        }
      },
      prolongPrice(event) {
        if (!this.priceProlongData.date_end) {
          event.preventDefault();
          this.$notify(setNotifyData('', 'Enter required fields', 'error'));
        } else {
          const data = getArrayByProperty(this.gridOptions.api.getSelectedRows(), 'id').map((e) => {
            return {
              status: 'active',
              id: e,
              date_end: moment(this.priceProlongData.date_end).format(DATE_FORMAT)
            }
          })
          this.$http.put('purchase/prices/', data).then(() => {
            const { translateColumnsProperly } = this
            this.$store.dispatch('priceLists/loadPrices', {price_list_id: this.param, translateColumnsProperly });
            this.getPriceInfo(this.param);
            this.$notify(setNotifyData('Success', 'Price information has been saved', 'success'));
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          });
        }
      },
      loadDocuments(cacheFlag) {
        if (cacheFlag) {
          this.$store.dispatch('priceLists/loadCommentsList', {id: this.param});
        } else {
          this.$store.dispatch('priceLists/loadDocumentsList', {id: this.param});
        }
      },
      loadComments(cacheFlag) {
        if (cacheFlag) {
          this.$store.dispatch('priceLists/loadCommentsList', {id: this.param});
        } else {
          this.$store.dispatch('priceLists/loadCommentsList', {id: this.param});
        }
      },
      getPriceInfo(id) {
        this.$http.get(`purchase/price_lists/${id}/`).then(handlerResponse).then((response) => {
          this.priceData = { ...response }

          const { translateColumnsProperly } = this
          this.$store.dispatch('priceLists/loadPrices', {price_list_id: id, translateColumnsProperly });
          this.$store.dispatch('location/setPathName', response.price_list_nr)
        }).catch((error) => {
          this.$router.push({path: `/price-list/new`});
          console.log(error);
          this.$notify(setNotifyData('', 'Price with such ID has been not found. You can create new one', 'error'));
        });
        this.findCurrency(this.priceData.currency_code)
      },
      countSelectedRows() {
        this.selectedRows = this.gridOptions.api.getSelectedRows()
        this.selectedRowsCount = getArrayByProperty(this.selectedRows, 'id') ? getArrayByProperty(this.selectedRows, 'id').length : 0
      },
      openHistoryModal() {
        this.historySettings.title = this.priceData.price_list_nr;
        this.$root.$emit('openHistoryModal', this.historySettings);
      },
      findCurrency (currencyCode = 'EUR') {
        //set default currency - EUR
        this.currency = this.currencies.find(e => e.code === currencyCode)
      },
      clearData() {
        this.$store.cache.delete('priceLists/loadDocumentsList', {id: this.param});
        this.$store.cache.delete('priceLists/loadCommentsList', {id: this.param});
        if (this.comments.length) {
          this.$store.commit('priceLists/setCommentsList', []);
        }
        if (this.documents.length) {
          this.$store.commit('priceLists/setDocumentsList', []);
        }
        this.$store.commit('priceLists/setData', []);
      }
    },
    computed: {
      ...mapGetters('partners', ['sellers', 'customers']),
      ...mapState('generic', ['currencies', 'currentRoutePermissions']),
      ...mapState('priceLists', ['documents', 'comments']),
      ...mapGetters('lots', {
        gridOptions: 'gridOptions'
      }),
      ...mapState('priceLists', ['pinnedRowData', 'prices', 'pricesColumns']),
      isOneOfSelectedIsCompleted () {
        return this.selectedRows.some(el => el.status === 'completed')
      },
      param() {
        return this.$route.params.id;
      },
      isNewPrice() {
        return this.param === 'new';
      },
      commonUrl() {
        return `purchase/price_lists/${this.param}/`;
      },
      isActivePrice() {
        return !!(this.priceData.status === 'active' || this.isNewPrice)
      },
      contractLabel() {
        return this.isNewPrice ? `${this.$i18n.t('common_content.new')} ${this.$i18n.t('common_content.price_list')}` : `${this.$i18n.t('common_content.price_list')} / ${this.priceData.price_list_nr}`
      },
      priceInfo() {
        return this.isNewPrice ? '' : `${this.priceData.created} / ${this.$i18n.t('common_content.creator')}: ${this.priceData.created_by}`
      },
      currentDate() {
        return new Date();
      },
      historySettings() {
        return {url: `price_list/?id=${this.param}`, title: ``};
      },
      gridHeight() {
        if (window.innerHeight > 1024) {
          return this.showCollapse ? {height: 'calc(100vh - 470px)'} : {height: 'calc(100vh - 270px)'};
        } else {
          return this.showCollapse ? {height: '400px'} : {height: 'calc(100vh - 270px)'};
        }
      },
      prolongPriceModalTitle() {
        return `${this.$i18n.t('modal_dialogs.purchase_price.prolong_price')}`
      }
    },
    async created () {
      cleanFilters(this.priceData);
      await this.$store.dispatch('partners/getCustomers');
      await this.$store.dispatch('generic/getCurrencies');
      await this.$store.dispatch('partners/getSellers');
    },
    async mounted() {
      if (!this.isNewPrice) {
        await this.$store.dispatch('priceLists/loadDocumentsList', {id: this.param});
        await this.$store.dispatch('priceLists/loadCommentsList', {id: this.param});
      } else {
        this.findCurrency()
      }
      if (!this.isNewPrice) {
        this.getPriceInfo(this.param);
      }
      this.$root.$on('updatePurchasePriceInfo', (payLoad) => {
        this.getPriceInfo(payLoad.id);
      })
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.clearData();
      });
    },
    beforeDestroy() {
      this.$root.$off('updatePurchasePriceInfo');
    },
    watch: {
      currency () {
        this.priceData.currency_code = this.currency?.code
      },
      currencies () {
        if (this.priceData.currency_code) {
          this.findCurrency(this.priceData.currency_code)
        }
      }
    }
  }
</script>

<style scoped>

  .grid {
    height: 450px;
  }

  .counter {
    color: red;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/modules/purchases/price-list/PurchasePrice.vue